// API Configuration
const normalizeGatewayOrigin = (value) => {
  if (typeof value !== "string") {
    return "";
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return "";
  }
  return trimmed.replace(/\/+$/, "").replace(/\/api$/i, "");
};

export const BASE_URL = normalizeGatewayOrigin(process.env.REACT_APP_API_URL) || "https://muzone.co";

// UI Constants
export const SCROLL_THRESHOLD = 14;
export const SCROLL_SHRINK_THRESHOLD = 80;
export const SCROLL_EXPAND_THRESHOLD = 30;
// Minimum scrollable range required to allow shrinking (px)
export const SCROLL_MIN_RANGE_FOR_SHRINK = 140;

// Header layout metrics for predictive checks
export const HEADER_NORMAL_HEIGHT = 200;
export const HEADER_SHRUNKEN_HEIGHT = 70;
export const HEADER_SHRINK_DELTA = HEADER_NORMAL_HEIGHT - HEADER_SHRUNKEN_HEIGHT; // 130
// Require at least this much remaining scroll range after shrink
export const SCROLL_MIN_RANGE_AFTER_SHRINK = 40;

// Gesture-based stabilizers
export const SHRINK_TRIGGER_DELTA = 40; // px user must scroll down after direction change before shrinking
export const EXPAND_TRIGGER_DELTA = 60; // px user must scroll up after direction change before expanding
export const HEADER_TOGGLE_MIN_INTERVAL_MS = 150; // debounce between state changes
